import React from 'react';
import { Box, Typography, useTheme, Container } from '@mui/material';

const VerificationLink = () => {
    const theme = useTheme();
    
    return (
        <Container >
            <Box
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 4,
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
                    p: { xs: 4, md: 8 },
                    position: 'relative',
                    overflow: 'hidden',
                    minHeight: '40vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    background: 'linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%)',
                    '&::before, &::after': {
                        content: '""',
                        position: 'absolute',
                        borderRadius: '50%',
                        opacity: 0.1,
                        zIndex: 0,
                    },
                    '&::before': {
                        backgroundColor: theme.palette.primary.main,
                        width: '40vw',
                        height: '40vw',
                        maxWidth: 600,
                        maxHeight: 600,
                        top: '-10%',
                        right: '-10%',
                    },
                    '&::after': {
                        backgroundColor: theme.palette.secondary.main,
                        width: '35vw',
                        height: '35vw',
                        maxWidth: 500,
                        maxHeight: 500,
                        bottom: '-10%',
                        left: '-8%',
                    },
                }}
            >
                <Box position="relative" zIndex={1} maxWidth="800px" mx="auto" width="100%">
                    <Typography 
                        variant="h3" 
                        component="h1"
                        sx={{
                            color: theme.palette.text.primary,
                            mb: 4,
                            fontWeight: 600,
                            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                            lineHeight: 1.2,
                            letterSpacing: '-0.5px',
                        }}
                    >
                        Thank you for signing up for CircleOne
                    </Typography>
                    <Typography 
                        variant="h6"
                        component="p"
                        sx={{
                            color: theme.palette.text.secondary,
                            mb: 3,
                            fontSize: { xs: '1.1rem', md: '1.3rem' },
                            lineHeight: 1.6,
                            maxWidth: '90%',
                        }}
                    >
                        Your AI-powered omni-channel CRM is being prepared.
                    </Typography>
                    <Box 
                        component="div"
                        sx={{
                            backgroundColor: 'rgba(25, 118, 210, 0.08)',
                            p: { xs: 2, sm: 3 },
                            borderRadius: 2,
                            borderLeft: `4px solid ${theme.palette.primary.main}`,
                            mt: 4,
                            display: 'flex',
                            alignItems: { xs: 'flex-start', sm: 'flex-start' },
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 1, sm: 2 },
                            overflow: 'visible',
                        }}
                    >
                        <Box 
                            component="span" 
                            sx={{
                                fontWeight: 600,
                                color: theme.palette.primary.main,
                                flexShrink: 0,
                                lineHeight: 1.6,
                            }}
                        >
                            Note:
                        </Box>
                        <Typography 
                            variant="body1"
                            sx={{
                                color: theme.palette.text.primary,
                                fontSize: '1.1rem',
                                lineHeight: 1.6,
                                margin: 0,
                                wordBreak: 'break-word',
                                overflow: 'visible',
                            }}
                        >
                            You'll receive a confirmation email shortly. The tenant creation process typically takes up to 2 hours to complete.
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Container>
    );
};

export default VerificationLink;
